import { render, staticRenderFns } from "./outpatientNurse.vue?vue&type=template&id=eef7cba6&scoped=true"
import script from "./outpatientNurse.vue?vue&type=script&lang=js"
export * from "./outpatientNurse.vue?vue&type=script&lang=js"
import style0 from "./outpatientNurse.vue?vue&type=style&index=0&id=eef7cba6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef7cba6",
  null
  
)

export default component.exports